export default [
  { 'currency': 'USD', 'flag': 'FlagUnitedStates-meiguo' },
  { 'currency': 'CAD', 'flag': 'FlagCanada-jianada' },
  { 'currency': 'AUD', 'flag': 'FlagAustralia-aodaliya' },
  { 'currency': 'EUR', 'flag': 'FlagAustria-oumeng' },
  { 'currency': 'EUR', 'flag': 'FlagAustria-aodili' },
  { 'currency': 'BDT', 'flag': 'FlagBangladesh-mengjialaguo' },
  { 'currency': 'EUR', 'flag': 'FlagBelgium-bilishi' },
  { 'currency': 'BRL', 'flag': 'FlagBrazil-baxi' },
  { 'currency': 'BGN', 'flag': 'FlagBulgaria-baojialiya' },
  { 'currency': 'CNY', 'flag': 'FlagChina-zhongguo' },
  { 'currency': 'CRC', 'flag': 'FlagCostaRica-gesidalijia' },
  { 'currency': 'CZK', 'flag': 'FlagCzech-jieke' },
  { 'currency': 'HRK', 'flag': 'FlagCroatia-keluodiya' },
  { 'currency': 'EUR', 'flag': 'FlagCyprus-saipulusi' },
  { 'currency': 'DKK', 'flag': 'FlagDenmark-danmai' },
  { 'currency': 'EGP', 'flag': 'FlagEgypt-aiji' },
  { 'currency': 'EUR', 'flag': 'FlagEstonia-aishaniya' },
  { 'currency': 'EUR', 'flag': 'FlagFinland-fenlan' },
  { 'currency': 'EUR', 'flag': 'FlagFrance-faguo' },
  { 'currency': 'EUR', 'flag': 'FlagGermany-deguo' },
  { 'currency': 'EUR', 'flag': 'FlagGreece-xila' },
  { 'currency': 'GTQ', 'flag': 'FlagGuatemala-weidimala' },
  { 'currency': 'GEL', 'flag': 'FlagGeorgia-gelujiya' },
  { 'currency': 'HKD', 'flag': 'FlagHongKong-xianggang' },
  { 'currency': 'HUF', 'flag': 'FlagHungary-xiongyali' },
  { 'currency': 'GBP', 'flag': 'FlagUnitedKingdom-yingguo' },
  { 'currency': 'INR', 'flag': 'FlagIndia-yindu' },
  { 'currency': 'ILS', 'flag': 'FlagIsrael-yiselie' },
  { 'currency': 'EUR', 'flag': 'FlagItaly-yidali' },
  { 'currency': 'IDR', 'flag': 'FlagIndonesia-yindunixiya' },
  { 'currency': 'ISK', 'flag': 'FlagIceland-bingdao' },
  { 'currency': 'EUR', 'flag': 'FlagIreland-aierlan' },
  { 'currency': 'JPY', 'flag': 'FlagJapan-riben' },
  { 'currency': 'EUR', 'flag': 'FlagLithuania-litaowan' },
  { 'currency': 'EUR', 'flag': 'FlagLuxembourg-lusenbao' },
  { 'currency': 'EUR', 'flag': 'FlagLatvia-latuoweiya' },
  { 'currency': 'MYR', 'flag': 'FlagMalaysia-malaixiya' },
  { 'currency': 'MXN', 'flag': 'FlagMexico-moxige' },
  { 'currency': 'MAD', 'flag': 'FlagMorocco-moluoge' },
  { 'currency': 'EUR', 'flag': 'FlagMalta-maerta' },
  { 'currency': 'EUR', 'flag': 'FlagNetherland-helan' },
  { 'currency': 'NPR', 'flag': 'FlagNepal-niboer' },
  { 'currency': 'NZD', 'flag': 'FlagNewzealand-xinxilan' },
  { 'currency': 'NOK', 'flag': 'FlagNorway-nuowei' },
  { 'currency': 'PKR', 'flag': 'FlagPakistan-bajisitan' },
  { 'currency': 'EUR', 'flag': 'FlagPortugal-putaoya' },
  { 'currency': 'PHP', 'flag': 'FlagPhilippines-feilvbin' },
  { 'currency': 'PLN', 'flag': 'FlagPoland-bolan' },
  { 'currency': 'RUB', 'flag': 'FlagRussia-eluosi' },
  { 'currency': 'RON', 'flag': 'FlagRomania-luomaniya' },
  { 'currency': 'BND', 'flag': 'FlagSingapore-xinjiapo' },
  { 'currency': 'SGD', 'flag': 'FlagSingapore-xinjiapo' },
  { 'currency': 'KRW', 'flag': 'FlagSouthKorea-hanguo' },
  { 'currency': 'EUR', 'flag': 'FlagSpain-xibanya' },
  { 'currency': 'LKR', 'flag': 'FlagSriLanka-sililanka' },
  { 'currency': 'SEK', 'flag': 'FlagSweden-ruidian' },
  { 'currency': 'CHF', 'flag': 'FlagSwitzerland-ruishi' },
  { 'currency': 'EUR', 'flag': 'FlagSlovakia-siluofake' },
  { 'currency': 'EUR', 'flag': 'FlagSlovenia-siluowenniya' },
  { 'currency': 'TRY', 'flag': 'FlagTurkey-tuerqi' },
  { 'currency': 'TWD', 'flag': 'FlagTaiwan' },
  { 'currency': 'THB', 'flag': 'FlagThailand-taiguo' },
  { 'currency': 'EUR', 'flag': 'FlagUnitedKingdom-yingguo' },
  { 'currency': 'UAH', 'flag': 'FlagUkraine-wukelan' },
  { 'currency': 'UYU', 'flag': 'FlagUruguay-wulagui' },
  { 'currency': 'AED', 'flag': 'FlagUAE-alianqiu' },
  { 'currency': 'VND', 'flag': 'FlagVietnam-yuenan' },
  { 'currency': '', 'flag': 'FlagOther' }
]
